import IssueClusterSuggestionsAPI from 'dashboard/api/issueClusterSuggestions';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
  meta: {
    count: 0,
    currentPage: 1,
  },
};

export const getters = {
  getSuggestions: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  async fetch({ commit }, params = {}) {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await IssueClusterSuggestionsAPI.get(params);
      commit('set', response.data.payload);
      commit('setMeta', response.data.meta);
      return response.data;
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async accept({ commit }, id) {
    commit('setUIFlag', { isUpdating: true });
    try {
      const response = await IssueClusterSuggestionsAPI.accept(id);
      commit('remove', id);
      return response.data;
    } finally {
      commit('setUIFlag', { isUpdating: false });
    }
  },

  async reject({ commit }, id) {
    commit('setUIFlag', { isUpdating: true });
    try {
      const response = await IssueClusterSuggestionsAPI.reject(id);
      commit('remove', id);
      return response.data;
    } finally {
      commit('setUIFlag', { isUpdating: false });
    }
  },
};

export const mutations = {
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  set($state, records) {
    $state.records = records || [];
  },
  setMeta($state, meta = {}) {
    $state.meta = {
      count: meta.count || 0,
      currentPage: meta.current_page || 1,
    };
  },
  remove($state, id) {
    $state.records = $state.records.filter(suggestion => suggestion.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
